export default __webpack_public_path__ + "static/ai-mi-career-banner-853d053c1e452ee7a9f036953636d120.jpg";